import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Classes from "./ViewInvoicePage.module.css";
import MoreDropDown from "./MoreDropDown";
import Logo from "../../../../LocalComp/Logo/Logo";
import DropDown from "../StatusDropDown/DropDown";

const LeftArrow = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 448 512">
        <path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z" />
    </svg>
);

export default function ViewInvoicePage() {
    const navigateTo = useNavigate();

    return (
        <div className={Classes.container}>
            <div className={Classes.header}>
                <button onClick={() => navigateTo("/invoices")} className={Classes.backButton}>
                    <LeftArrow height='12px' fill='#969696' />
                    <h5>Invoices</h5>
                </button>
                <div className="flexAlign10" >
                    <button className={Classes.addBtn}>
                        <svg xmlns="http://www.w3.org/2000/svg" height='12px' fill="white" viewBox="0 0 512 512"><path d="M256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM244.7 395.3l-112-112c-4.6-4.6-5.9-11.5-3.5-17.4s8.3-9.9 14.8-9.9l64 0 0-96c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 96 64 0c6.5 0 12.3 3.9 14.8 9.9s1.1 12.9-3.5 17.4l-112 112c-6.2 6.2-16.4 6.2-22.6 0z" /></svg>
                        <h5>Download</h5>
                    </button>
                    <MoreDropDown />
                </div>
            </div>

            <div className={Classes.hero} >
                <div className={Classes.grid} >
                    <div className={Classes.heroLeft}>
                        <div className={Classes.logo}>
                            <Logo alwaysShowText={true} />
                        </div>
                        <h5 className={`${Classes.lightText} mt-10`} >Company name</h5>
                        <div className={Classes.invoicedBy} >
                            <h5>Invoiced to</h5>
                            <p className={`${Classes.lightText}`} >
                                9999 sled way
                                Tampa, 11234
                                Florida
                                United States
                            </p>
                        </div>
                    </div>
                    <div className={Classes.heroRight} >
                        <div className={Classes.invoice} >
                            <div className="flexEnd10" >
                                <h3> Invoice </h3>
                                <DropDown selectedValue="Paid" isDropDown={false} />
                            </div>
                            <div className={Classes.invoiceListCon} >
                                <div>
                                    <h5 className={Classes.lightText} >Invoice number</h5>
                                    <h5 className={Classes.lightText} >A-1</h5>
                                </div>
                                <div>
                                    <h5 className={Classes.lightText} >Unique ID</h5>
                                    <h5 className={Classes.lightText} >33DSH32</h5>
                                </div>
                                <div>
                                    <h5 className={Classes.lightText} >Date issued</h5>
                                    <h5 className={Classes.lightText} >Mar 1, 2025</h5>
                                </div>
                                <div>
                                    <h5 className={Classes.lightText} >Date paid</h5>
                                    <h5 className={Classes.lightText} >Mar 1, 2025</h5>
                                </div>
                                <div>
                                    <h5 className={Classes.lightText} >Payment method</h5>
                                    <h5 className={Classes.lightText} >Stripe</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className={Classes.hero2}>
                    <table className={Classes.table}>
                        <thead>
                            <tr>
                                <th> <h5 className={Classes.lightDarkText} > Item </h5> </th>
                                <th> <h5 className={Classes.lightDarkText} > Price </h5> </th>
                                <th> <h5 className={Classes.lightDarkText} > Quantity </h5> </th>
                                <th> <h5 className={Classes.lightDarkText} > Total </h5> </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <h5 className={Classes.itemLink} >
                                        587FHA9
                                    </h5>
                                </td>
                                <td> <h5> $800.00 </h5> </td>
                                <td> <h5> x1 </h5> </td>
                                <td> <h5> $800.00 </h5> </td>
                            </tr>
                            <tr>
                                <td>
                                </td>
                                <td></td>
                                <td> <h5 className={Classes.fw600} >Subtotal</h5> </td>
                                <td> <h5>$800.00</h5> </td>
                            </tr>
                            <tr>
                                <td>
                                </td>
                                <td></td>
                                <td> <h5>Total</h5> </td>
                                <td> <h5>USD $800.00</h5> </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div >
    );
}